import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {AssistanceProvidedType, ExtensionCategory} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from "../../services/user.service";
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-assistance-type',
  templateUrl: './add-assistance-type.component.html',
  styleUrls: ['./add-assistance-type.component.scss']
})
export class AddAssistanceTypeComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  assistance: AssistanceProvidedType = {} as AssistanceProvidedType;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  filteredCategories = new ReplaySubject<ExtensionCategory[]>(1);


  constructor(private userService: UserService, public dataService: DataService) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateAssistanceType(v.assistance);
    });
    this.updateAssistanceType({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {
    this.dataService.categories.pipe(
      map(categories => {
        // Get all non-archived categories
        const activeCategories = categories.filter(cat => !cat.archived);

        // If we have a selected category that's archived, add it to the list
        if (this.assistance.category) {
          const selectedCategory = categories.find(cat =>
            cat.id === this.assistance.category && cat.archived);
          if (selectedCategory) {
            activeCategories.push(selectedCategory);
          }
        }

        return activeCategories;
      })
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });

  }

  ngOnDestroy() {
    this.filteredCategories.complete();
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  updateAssistanceType(input: any) {
    this.assistance = {
      id: input.id || null,
      name: input.name || null,
      category: input.category || null
    } as AssistanceProvidedType;
    console.log('AddAssistanceType::: ', this.assistance);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveAssistanceType() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.assistance = this.assistance;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
